import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class WFESendToVendorEditParametersDto {
    workflowId: number;
    workflowStatus: string; // 	NOTE: Required for most endpoints of workflow editor except for getting data entry editor
    communityId: number;
    vendorCode: string; // 	NOTE: Payee Type should be vendor

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    invoiceDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    invoiceNumber: string; // 	NOTE: Max length is 50 characters
    specialHandlingId: number;
}
